import { createTheme } from '@material-ui/core';
import { cartoThemeOptions } from './cartoTheme';

const theme = createTheme(cartoThemeOptions);

export default theme;
